var script_loaded = false;

function loadJSscripts() {
  if (script_loaded) return;
  script_loaded = true;

  if (typeof observer !== 'undefined' && observer && observer.disconnect) {
    observer.disconnect();
  }

  document.querySelectorAll('iframe.lazy').forEach(function (frame) {
    if (frame.dataset.src != null) frame.src = frame.dataset.src;
  });

  Array.prototype.slice.call(document.querySelectorAll('script[data-src]')).forEach(function (el) {
    el.setAttribute('src', el.getAttribute('data-src'));
    el.removeAttribute('data-src');
  });

  Array.prototype.slice
    .call(document.querySelectorAll('script[type="text/lazyload"]'))
    .forEach(function (el) {
      var fresh = document.createElement('script');
      for (var a = 0; a < el.attributes.length; a++) {
        var attr = el.attributes[a];
        if (attr.name === 'type') continue;
        fresh.setAttribute(attr.name, attr.value);
      }
      fresh.type = 'text/javascript';
      fresh.innerHTML = el.innerHTML;
      el.parentNode.replaceChild(fresh, el);
    });

  Array.prototype.slice.call(document.querySelectorAll('link[data-href]')).forEach(function (el) {
    el.setAttribute('href', el.getAttribute('data-href'));
    el.removeAttribute('data-href');
  });

  document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
}

var activityEvents = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart',
  'click',
  'keypress',
  'touchmove'
];
activityEvents.forEach(function (evt) {
  window.addEventListener(evt, loadJSscripts, { passive: true });
});

/* C-24 : fallback idle / timeout (~3.5s) si aucun geste */
function scheduleIdleLoad() {
  var delay = 3500;
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () {
      loadJSscripts();
    }, { timeout: delay });
  } else {
    setTimeout(loadJSscripts, delay);
  }
}

if (window.addEventListener) {
  window.addEventListener('load', scheduleIdleLoad, false);
} else if (window.attachEvent) {
  window.attachEvent('onload', scheduleIdleLoad);
} else {
  window.onload = scheduleIdleLoad;
}
